import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AppSettingsService} from '../../services/app-settings.service';
import {Option, StaticMethods} from '../../model/GeneralModels';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-select-field',
  template: `
    <mat-form-field appearance="legacy" class="thin-appearance" [formGroup]="Group" [ngSwitch]="autoComplete">
      <mat-label>{{fieldLabel}}</mat-label>
      <div *ngSwitchCase="true">
        <input type="text"
               placeholder="{{fieldLabel}}"
               aria-label="string"
               *ngIf="autoComplete"
               matInput
               [formControlName]="fieldName"
               [matAutocomplete]="auto"
               (ngModelChange)="onChangeCallback($event)">
        <mat-autocomplete #auto="matAutocomplete" [ngSwitch]="type">
          <div *ngSwitchCase="'stringList'">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
          </div>
          <div *ngSwitchDefault>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.label">
              {{option.label}}
            </mat-option>
          </div>
        </mat-autocomplete>
      </div>
      <div *ngSwitchDefault>
        <mat-select panelClass="mat-select-option" (selectionChange)="onChangeCallback($event)"
                    [formControlName]="fieldName" [ngSwitch]="type">
          <div *ngSwitchCase="'stringList'">
            <mat-option>انتخاب کنید</mat-option>
            <mat-option *ngFor="let option of options"
                        value="{{option}}">{{AppSettings.translateEnglish(option, translation)}}</mat-option>
          </div>
          <div *ngSwitchDefault>
            <mat-option>انتخاب کنید</mat-option>
            <mat-option *ngFor="let option of options"
                        value="{{option.value}}">{{AppSettings.translateEnglish(option.label, translation)}}</mat-option>
          </div>
        </mat-select>
      </div>
      <!--      <mat-icon *ngIf="Icon" matSuffix>{{iconClass}}</mat-icon>-->
      <mat-error *ngIf="Group.controls[fieldName].hasError('required')">لطفا گزینه ی مورد نظر را انتخاب نمایید
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: [],
  styles: [`
    mat-form-field {
      width: 100%;
      font-weight: 300;
      font-family: iran-sans, "B yekan", sans-serif;
    }

    .thin-appearance {
      padding: 0 0 0 0 !important;
    }

    .mat-select-arrow {
      visibility: hidden;
    }

    mat-option {
      text-align: right;
      font-family: iran-sans, "B yekan", sans-serif;

    }

    .mat-select-option .mat-select-panel {
      background: rgba(0, 255, 0, 0.5) !important;
      font-family: iran-sans, "B yekan", sans-serif;
    }

    .mat-option.mat-active {
      background: rgb(83, 126, 197) !important;
      color: rgb(255, 255, 255) !important;
    }

    .mat-select-arrow-wrapper {
      display: none;
      vertical-align: middle;
    }

    .mat-select-value {
      display: table-cell;
      max-width: 0;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 25px;
    }

    .required mat-label {
      font-weight: bold;
    }

    .required mat-label:after {
      color: #e32;
      content: ' *';
      display: inline;
    }
  `]
})
export class SelectFieldComponent implements OnInit, AfterViewChecked, OnChanges {
  @Input() Group: FormGroup;
  @Input() fieldName: string;
  @Input() fieldLabel: string;
  @Input() options: any[] | Option[] | string[];
  @Input() Icon: boolean;
  @Output() OnChange = new EventEmitter<File>();
  @Input() Class: string;
  @Input() even: boolean;
  @Input() iconClass: string;
  type = 'select';
  @Input() value: any;
  @Input() autoComplete = false;
  filteredOptions: Observable<string[] | Option[]>;
  @Input() testAutoFill: boolean;
  @Input() viewList: any = {};
  @Input() translation: any = {};

  constructor(public AppSettings: AppSettingsService) {
  }

  ngOnInit() {
    if (this.options.length && (typeof this.options[0] === 'string' || typeof this.options[0] === 'number')) {
      this.type = 'stringList';
    }
    if (this.Icon) {
      this.iconClass = 'icon ' + StaticMethods.getIcon(this.fieldName);
    }
    if (this.autoComplete) {
      this.filteredOptions = this.Group.controls[this.fieldName].valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    }
    if (this.value) {
      if (typeof this.value === 'string' && this.type !== 'stringList') {
        const selectedOption = this.options.find(option => {
          return option.label === this.value;
        });
        if (selectedOption) {
          this.Group.controls[this.fieldName].patchValue(selectedOption.value);
        }
      } else {
        this.Group.controls[this.fieldName].patchValue(this.value);
      }
    }
  }

  ngAfterViewChecked() {
    if (typeof this.options[0] === 'string' || typeof this.options[0] === 'number') {
      this.type = 'stringList';
    }
  }

  onChangeCallback(event) {
    console.log('changed: ', this.Group.controls[this.fieldName].value, this.Group.value[this.fieldName]);
    this.Group.updateValueAndValidity();
    if (this.Group.controls[this.fieldName].value) {
      if (this.type === 'stringList') {
        this.viewList[this.fieldName] = this.Group.controls[this.fieldName].value;
      } else {
        const selectedOption = this.options.find(option => {
          return option.value === StaticMethods.dynamicParse(event.value, typeof option.value);
        });
        console.log(selectedOption);
        this.viewList[this.fieldName] = selectedOption.label;
      }
      this.OnChange.emit(this.Group.controls[this.fieldName].value);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (this.type === 'stringList') {
      return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }
    return this.options.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!environment.production && this.testAutoFill) {
      const validators = this.Group.controls[this.fieldName].validator(this.Group.controls[this.fieldName]);
      console.log(validators);
    }
    if (this.value) {
      this.Group.controls[this.fieldName].patchValue(this.value);
      this.onChangeCallback(this.value);
    }
  }
}
